/*
OutgoingReports.js - Index Component for Outgoing Reports
*/

// NPM MODULES
import React, { useState, useEffect, Fragment, useCallback } from 'react';
import { Box } from '@mui/material';

// NETWORKING
import useOutgoingReportRequest from '../../requests/OutgoingReportRequest';

// FORMATTED MESSAGES
import OutgoingReportsFormattedMessages from '../../messages/reports/OutgoingReportsFormattedMessages';

import { ReportsRoutes } from '../../routes/ReportsRoutes';

// OUR COMPONENTS
import DateRangeSelector from '../../components/common/DateRangeSelector';
import Layout from '../../components/layouts/Layout';
import OutgoingReportsTable from '../../components/reports/outgoing/OutgoingReportsTable';
import OutgoingReportsTableRow from '../../components/reports/outgoing/OutgoingReportsTableRow';
import Loader from '../../components/common/Loader';

const Outgoing = ({
  customer,
  outgoingData,
  errorHandler,
  accessLevel,
  accessType,
}) => {
  const [reportsList, setReportsList] = useState(null);
  const [data, setData] = useState([]);
  const [dataExists, setDataExists] = useState(false);
  const [loading, setLoading] = useState(true);
  const [totals, setTotals] = useState({
    Direct: 0,
    Standard: 0,
    Replies: 0,
    Sent: 0,
    Pending: 0,
  });
  const [selectedData, setSelectedData] = useState(null);
  const [activePage, setActivePage] = useState('list');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const { getReportData } = useOutgoingReportRequest();

  useEffect(() => {
    if (customer && customer !== null) {
      if (outgoingData && outgoingData.length !== 0) {
        console.log('Have outgoing data:', outgoingData);
        setData(outgoingData.smslist);
        setDataExists(true);
        formatData(outgoingData.smslist);
      }
    }
  }, [customer, outgoingData]);

  const sortList = (data) => {
    return data.slice().sort((a, b) => {
      if (a.device_name < b.device_name) {
        return -1;
      }
      if (a.device_name > b.device_name) {
        return 1;
      }
      return 0;
    });
  };

  /*
    Formats the data in a manner required for the Table
    to properly display the data
  */
  const formatData = (data) => {
    try {
      const formattedData = data?.map((el) => (
        <OutgoingReportsTableRow
          key={el.device_id}
          id={el.device_id}
          deviceName={el.device_name}
          type={el.device_type}
          replyTn={el.reply_tn}
          txt={el.totals.messages_sent}
          dir={el.totals.direct_sent}
          rem={el.totals.reminders_sent}
        />
      ));

      setReportsList(formattedData);
      setLoading(false);
    } catch (e) {
      console.log('data error:', e);
    }
  };

  const backButton = () => {
    setActivePage('list');
  };

  /*
    Handles searching Outgoing Data between two dates
  */
  const handleOutgoingDataSearch = useCallback(async () => {
    try {
      setLoading(true);
      const result = await getReportData(fromDate, toDate, errorHandler);

      setData(result);
      formatData(result);
    } catch (e) {
      // TODO - handle error
      setLoading(false);
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    if (fromDate && toDate) handleOutgoingDataSearch();
  }, [handleOutgoingDataSearch]);

  const changePage = (page, value) => {
    setActivePage(page);
    setSelectedData(value);
  };

  /*
    Generates the Search Tools for querying the data
  */
  const generateSearchTools = () => {
    return (
      <Box sx={{ marginBottom: { xs: 4, md: 2 } }}>
        <DateRangeSelector
          handleDateSearch={() => handleOutgoingDataSearch()}
          parentStartDate={fromDate}
          setParentStartDate={setFromDate}
          parentEndDate={toDate}
          setParentEndDate={setToDate}
        />
      </Box>
    );
  };

  const reloadPage = () => {
    window.location.reload(1);
  };

  if (accessLevel === '3' && accessType === '3') {
    return (
      <Layout
        routes={ReportsRoutes}
        title={OutgoingReportsFormattedMessages.outgoingReportsTitle}
        accessLevel={accessLevel}
        accessType={accessType}
      >
        {generateSearchTools()}
        {loading ? (
          <Loader />
        ) : (
          <OutgoingReportsTable changePage={changePage} list={reportsList} />
        )}
      </Layout>
    );
  }
  return null;
};

export default Outgoing;
